import { AdminApi } from 'stylemix-vue-admin'

export default class BookingsApi extends AdminApi {
  constructor(parameters) {
    super('bookings', parameters)
  }

  /**
   * @inheritDoc
   */
  all(config = {}) {
    return this.submit('get', `/${this.endpoint}/my`, null, config)
  }

  clearPendingChanges(changesId) {
    return this.submit(
      'post',
      `${this.endpoint}/pending-changes/${changesId}/clear`,
    )
  }

  createPendingChangesInvoice(changesId) {
    return this.submit(
      'post',
      `${this.endpoint}/pending-changes/${changesId}/invoice`,
    )
  }
}
